import React, { useState, useEffect } from "react";
import { Card, Badge, Button, Pagination, Spinner } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { apiClient } from '../api/ApiClient';
import FilterModal from './FilterModal';
import useFastPhotos from '../fastPhotos/useFastPhotos';

import ProfileModal from '../profileModelPopup/ProfileModal';
import '../profileModelPopup/ProfileModal.css';

import './SearchPage.css';

const SearchPage = () => {
    const navigate = useNavigate();
    const [showProfileModal, setShowProfileModal] = useState(false);
    const [selectedProfile, setSelectedProfile] = useState(null);


    const handleCardClick = (e, result) => {
        // Stop event bubbling
        e.preventDefault();
        e.stopPropagation();
        
        // Only show modal if not clicking the Link
        const isLink = e.target.closest('.favorite-card-link');
        if (!isLink) {
            setSelectedProfile(result);
            setShowProfileModal(true);
        }
    };

    // Handle click on a close match profile
    const handleCloseMatchClick = (e, photo) => {
        e.preventDefault();
        e.stopPropagation();
        
        const token = localStorage.getItem('token');
        if (token) {
            // Navigate to the profile page
            navigate(`/profile/view/1/${photo[0]}`);
        } else {
            navigate('/login');
        }
    };

    // Handle click on a search result profile
    const handleSearchResultClick = (e, result) => {
        e.preventDefault();
        const token = localStorage.getItem('token');

        if (token) {
            // Navigate to the profile page
            navigate(`/profile/view/${result[0]}/${result[19]}/${result[0]}`);
        } else {
            navigate('/login');
        }
    };

    const [searchParams, setSearchParams] = useState({
        P_SEARCH_ZIP: '10001',
        P_SEEKING: 'F',
        P_AGE_START: '21',
        P_AGE_END: '55',
        P_MILES_LIMIT: '100',
        P_MEMBER_id: '55',
        P_BODY_WHERE: '',
        P_ETH_WHERE: '',
        P_REL_WHERE: '',
        P_EDU_WHERE: '',
        pass_member_type_id: '1'
    });

    const [bodyArrayModel, setBodyArrayModel] = useState([]);
    const [ethnicityArrayModel, setEthnicityArrayModel] = useState([]);
    const [relationshipArrayModel, setRelationshipArrayModel] = useState([]);
    const [allResults, setAllResults] = useState([]);
    const [loadingResults, setLoadingResults] = useState(false);
    const [errorResults, setErrorResults] = useState(null);

    const { fastPhotos, loading, error } = useFastPhotos();

    const [showBodyModal, setShowBodyModal] = useState(false);
    const [showRelationshipModal, setShowRelationshipModal] = useState(false);
    const [showEthnicityModal, setShowEthnicityModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(21);

    const bodyOptions = [
        { id: 1, code: "BODY_SLENDER", label: "Slender" },
        { id: 2, code: "BODY_ATHLETIC", label: "Athletic" },
        { id: 3, code: "BODY_FIT", label: "Fit" },
        { id: 4, code: "BODY_AVERAGE", label: "Average" },
        { id: 5, code: "BODY_EXTRA", label: "Extra" },
        { id: 6, code: "BODY_THICK", label: "Thick" },
        { id: 7, code: "BODY_LARGE", label: "Large" },
        { id: 8, code: "BODY_VOLUPTUOUS", label: "Voluptuous" }
    ];

    const relationshipOptions = [
        { id: 1, code: "REL_NEVERMARRIED", label: "Never Married" },
        { id: 2, code: "REL_DIVORCED", label: "Divorced" },
        { id: 3, code: "REL_WIDOWED", label: "Widowed" },
        { id: 4, code: "REL_SEPARTED", label: "Separated" }
    ];

    const ethnicityOptions = [
        { id: 1, code: "ETH_ASIAN", label: "Asian" },
        { id: 2, code: "ETH_BLACK", label: "African American (Black)" },
        { id: 3, code: "ETH_EAST_INDIAN", label: "East Indian" },
        { id: 4, code: "ETH_LATINO_HISPANIC", label: "Latino/Hispanic" },
        { id: 5, code: "ETH_MIDDLE_EASTERN", label: "Middle Eastern" },
        { id: 6, code: "ETH_NATIVE_AMERICAN", label: "Native American" },
        { id: 7, code: "ETH_PACIFIC_ISLANDER", label: "Pacific Islander" },
        { id: 8, code: "ETH_WHITE_CAUCASIAN", label: "Caucasian (White)" },
        { id: 9, code: "ETH_INTER_RACIAL", label: "Inter-Racial" },
        { id: 10, code: "ETH_OTHER", label: "Other" }
    ];

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSearchParams(prevParams => ({ ...prevParams, [name]: value }));
    };

    const submitBasic = async () => {
        setLoadingResults(true);
        setErrorResults(null);

        const updatedSearchParams = {
            ...searchParams,
            P_MEMBER_id: parseInt(searchParams.P_MEMBER_id),
            P_AGE_START: parseInt(searchParams.P_AGE_START),
            P_AGE_END: parseInt(searchParams.P_AGE_END),
            P_BODY_WHERE: bodyArrayModel.map(body => body.code).join(','),
            P_ETH_WHERE: ethnicityArrayModel.map(ethnicity => ethnicity.code).join(','),
            P_REL_WHERE: relationshipArrayModel.map(relationship => relationship.code).join(','),
            P_MILES_LIMIT: parseInt(searchParams.P_MILES_LIMIT),
            P_PASS_LIMIT: parseInt(searchParams.P_PASS_LIMIT) || 0,
            P_PASS_LIMIT2: parseInt(searchParams.P_PASS_LIMIT2) || 0,  
            pass_member_type_id: parseInt(searchParams.pass_member_type_id)
        };

        try {
            const response = await apiClient.post('/rest/basic/search', updatedSearchParams);
            if (response.data && response.data.content) {
                setAllResults(response.data.content);
                setCurrentPage(0);
            }
        } catch (error) {
            console.error('Error fetching search results:', error);
            setErrorResults('Error fetching search results. Please try again later.');
        } finally {
            setLoadingResults(false);
        }
    };

    useEffect(() => {
        submitBasic();
    }, []);

    const getCurrentPageResults = () => {
        const startIndex = currentPage * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        return allResults.slice(startIndex, endIndex);
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const renderPagination = () => {
        const totalPages = Math.ceil(allResults.length / itemsPerPage);
        let items = [];
        const maxVisiblePages = 5;

        if (totalPages <= maxVisiblePages) {
            for (let number = 0; number < totalPages; number++) {
                items.push(
                    <Pagination.Item key={number} active={number === currentPage} onClick={() => handlePageChange(number)}>
                        {number + 1}
                    </Pagination.Item>
                );
            }
        } else {
            items.push(
                <Pagination.First key="first" onClick={() => handlePageChange(0)} disabled={currentPage === 0} />,
                <Pagination.Prev key="prev" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0} />
            );

            const startPage = Math.max(0, currentPage - Math.floor(maxVisiblePages / 2));
            const endPage = Math.min(totalPages - 1, startPage + maxVisiblePages - 1);

            if (startPage > 0) {
                items.push(<Pagination.Ellipsis key="ellipsis-start" />);
            }

            for (let number = startPage; number <= endPage; number++) {
                items.push(
                    <Pagination.Item key={number} active={number === currentPage} onClick={() => handlePageChange(number)}>
                        {number + 1}
                    </Pagination.Item>
                );
            }

            if (endPage < totalPages - 1) {
                items.push(<Pagination.Ellipsis key="ellipsis-end" />);
            }

            items.push(
                <Pagination.Next key="next" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages - 1} />,
                <Pagination.Last key="last" onClick={() => handlePageChange(totalPages - 1)} disabled={currentPage === totalPages - 1} />
            );
        }

        return <Pagination>{items}</Pagination>;
    };

    return (
        <div className="container-1024">
            <div className="search-page">
                <div className="search-filters">
                    <label className="filter-label">
                        Seeking:&nbsp;
                        <select name="P_SEEKING" value={searchParams.P_SEEKING} onChange={handleInputChange}>
                            <option value="F">Woman</option>
                            <option value="M">Man</option>
                        </select>
                    </label>

                    <label className="filter-label">
                        Age Range:
                        <input
                            type="number"
                            className="input-line"
                            name="P_AGE_START"
                            value={searchParams.P_AGE_START}
                            onChange={handleInputChange}
                            placeholder="From"
                        />
                        to
                        <input
                            type="number"
                            className="input-line"
                            name="P_AGE_END"
                            value={searchParams.P_AGE_END}
                            onChange={handleInputChange}
                            placeholder="To"
                        />
                    </label>

                    <label className="filter-label">
                        Distance:
                        <select name="P_MILES_LIMIT" value={searchParams.P_MILES_LIMIT} onChange={handleInputChange}>
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="15">15</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="75">75</option>
                            <option value="100">100</option>
                        </select>
                    </label>

                    <label className="filter-label">
                        Zipcode:
                        <input
                            type="text"
                            className="input-line"
                            name="P_SEARCH_ZIP"
                            value={searchParams.P_SEARCH_ZIP}
                            onChange={handleInputChange}
                            placeholder="Zipcode"
                        />
                    </label>
                </div>
                
                <div className="search-actions d-flex justify-content-between align-items-center mt-3">
                    <Button className="me-2" onClick={() => setShowBodyModal(true)}>Body Type</Button>
                    <Button className="me-2" onClick={() => setShowRelationshipModal(true)}>Relationship</Button>
                    <Button className="me-2" onClick={() => setShowEthnicityModal(true)}>Ethnicity</Button>
                    <Button className="me-2" onClick={submitBasic} variant="success">Update Search Results</Button>
                    <select 
                        value={itemsPerPage} 
                        onChange={(e) => {
                            setItemsPerPage(Number(e.target.value));
                            setCurrentPage(0);
                        }}
                    >
                        <option value={20}>20 per page</option>
                        <option value={50}>50 per page</option>
                        <option value={100}>100 per page</option>
                    </select>
                </div>
            </div>

            <div className="results-area">
                {errorResults ? <p>{errorResults}</p> : null}
                {loadingResults && (
                    <div className="loading-indicator">
                        <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                        <p>Loading search results...</p>
                    </div>
                )}
                
                {!loadingResults && !errorResults && (
                    <>
                        <div className="pagination-controls">
                            {renderPagination()}
                        </div>
                        <div className="results-content">
                            <div className="results-center-details">
                                <div className="container d-flex flex-wrap justify-content-left">
                                {getCurrentPageResults().map((result, index) => (
                                    <Card 
                                        key={index} 
                                        className="search-img-card"
                                    >
                                        <div className="card-content-wrapper">
                                            <Card.Img 
                                                variant="top" 
                                                src={`https://pics.netfixup.com/${result[28]}/${result[26]}`}
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  setSelectedProfile(result);
                                                  setShowProfileModal(true);
                                                }}
                                                style={{cursor: 'pointer'}}
                                            />
                                            {/* Changed from Link to anchor with onClick handler */}
                                            <a 
                                                href={`/profile/view/${result[0]}/${result[19]}/${result[0]}`}
                                                className="profile-link"
                                                onClick={(e) => handleSearchResultClick(e, result)}
                                            >
                                            </a>
                                            <Card.Body>
                                                <Card.Title>{result[1]}</Card.Title>
                                                <Card.Text>
                                                    <b>Age:</b> {result[8]}<br />
                                                    <b>Gender:</b> {result[11]}<br />
                                                    <b>Looking for:</b> {result[12]}<br />
                                                    <b>Location:</b> {result[21]}, {result[22]}<br />
                                                    <b>Online:</b> {result[29]}<br />
                                                    <b>Member Type:</b> {result[17]}<br />
                                                </Card.Text>
                                            </Card.Body>
                                        </div>
                                    </Card>
                                ))}
                                </div>
                            </div>

                            <div className="results-right-sidebar">
                                <h5>Close Matches</h5>
                                {loading ? (
                                    <p>Loading...</p>
                                ) : error ? (
                                    <p>{error}</p>
                                ) : fastPhotos.length > 0 ? (
                                    fastPhotos.map((photo, index) => (
                                        <Card 
                                            key={index} 
                                            className="fast-photo-card-side"
                                            onClick={(e) => handleCardClick(e, photo)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            {/* Changed from Link to anchor with onClick handler */}
                                            <a 
                                                href={`/profile/view/1/${photo[0]}`}
                                                onClick={(e) => handleCloseMatchClick(e, photo)}
                                            >
                                                <Card.Img 
                                                    variant="top" 
                                                    src={`https://pics.netfixup.com/${photo[7]}${photo[6]}`} 
                                                />
                                            </a>
                                            <Badge pill bg="light" text="dark">
                                                {photo[2]}
                                            </Badge>
                                        </Card>
                                    ))
                                ) : (
                                    <p>No Fast Photos Found</p>
                                )}
                            </div>
                        </div>
                        <div className="pagination-controls">
                            {renderPagination()}
                        </div>
                    </>
                )}
            </div>

            <FilterModal
                title="Body Type"
                options={bodyOptions}
                selectedOptions={bodyArrayModel}
                setSelectedOptions={setBodyArrayModel}
                show={showBodyModal}
                handleClose={() => setShowBodyModal(false)}
            />

            <FilterModal
                title="Relationship"
                options={relationshipOptions}
                selectedOptions={relationshipArrayModel}
                setSelectedOptions={setRelationshipArrayModel}
                show={showRelationshipModal}
                handleClose={() => setShowRelationshipModal(false)}
            />

            <FilterModal
                title="Ethnicity"
                options={ethnicityOptions}
                selectedOptions={ethnicityArrayModel}
                setSelectedOptions={setEthnicityArrayModel}
                show={showEthnicityModal}
                handleClose={() => setShowEthnicityModal(false)}
            />

            <ProfileModal
                show={showProfileModal}
                onHide={() => setShowProfileModal(false)}
                profileData={selectedProfile}
                showReply={false}
            />
        </div>
    );
};

export default SearchPage;